import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {
  "contentType": "contentPage",
  "path": "/research-focus",
  "title": "Research Focus"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`AI & Machine Learning`}</p>
    <p>{`Cyber Security & Threat Intelligence`}</p>
    <p>{`Computer Vision & Smart Monitoring`}</p>
    <p>{`NLP and Human-Computer-Interface `}</p>
    <p>{`IoT & Smart City Applications`}</p>
    <p>{`Data Analytic Applications `}</p>
    <p>{`Low-Cost Power-Efficient Hardware Design`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      